import React from 'react';

const DowneyFooter = () => {
    return (
        <div className={'DowneyFooter'}>
            <div>Downey Animal Care Center</div>
            <div>11258 Garfield Ave.</div>
            <div>Downey, CA 90242</div>
            <div>(562) 940-6898</div>
        </div>
    );
};

export default DowneyFooter;
